import { useGraphQLContext } from "../../context/graphQLContext";
import { useQuery } from "@tanstack/react-query";
import request from "graphql-request";
import { getFrameTexture, listChairFrameOptions } from "../../queries/frame";

export type FrameTexture = {
    asset: {
        url: string;
        title: string;
        width: number;
        height: number;
    };
};

export type Texture = {
    shininess: number;
    textureName: string;
    description: string;
    cost: number;
    texture: Array<{ id: string; url: string }>;
};

export type Frame = {
    id: string;
    frameCost: number;
    frame: Array<{
        id: string;
        frameName: string;
        textures: Array<Texture>;
    }>;
};

export type ChairFrameOptions = {
    frames: Array<Frame>;
};

export type ChairFrameOptionsOut = {
    chairEntries: Array<ChairFrameOptions>;
};

export const useGetFrameTexture = (data: { id: string }) => {
    const graphqlOptions = useGraphQLContext();

    return useQuery<FrameTexture>({
        queryKey: ["frameTexture", data.id],
        queryFn: async () => {
            const variables = { ...data };
            return request({
                ...graphqlOptions,
                document: getFrameTexture,
                variables: variables,
            });
        },
        enabled: data.id !== "",
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        keepPreviousData: true,
    });
};

export const useListChairFrameOptions = (data: { id: string }) => {
    const graphqlOptions = useGraphQLContext();

    return useQuery<ChairFrameOptionsOut>({
        queryKey: ["chairFrameOptions", data.id],
        queryFn: async () => {
            const variables = { ...data };
            return request({
                ...graphqlOptions,
                document: listChairFrameOptions,
                variables: variables,
            });
        },
        enabled: data.id !== "",
        refetchOnMount: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
};
